<template>
  <div class="custom-modal-mask" v-if="visible" @click.self="close">
    <div class="custom-modal fav-dialog" style="width: 800px;">
      <div class="custom-modal-header">
        <span class="modal-title">收藏夹 <span class="count">共{{ favTotal }}题</span></span>
        <span class="custom-modal-close" @click="close">&times;</span>
      </div>
      <div class="custom-modal-body">
        <div v-for="(item, idx) in favList" :key="item.id" class="fav-list-item">
          <div class="fav-list-head">
            <div class="fav-list-head-row">
              <span class="fav-list-num">{{ (favPage - 1) * favPageSize + idx + 1 }}</span>
              <span class="fav-list-type" :class="{ judge: item.type === 'JUDGMENT', essay: item.type === 'ESSAY' }">{{ quesMap[item.type] || item.type }}</span>
              <span class="fav-list-time" v-if="item.createdTime">{{ item.createdTime }}</span>
              <span class="fav-list-delete" @click="deleteFavItem(item)">删除</span>
            </div>
            <div class="fav-list-title" v-html="item.content"></div>
          </div>
          <ul class="q-options" v-if="item.options && item.options.length">
            <li v-for="(opt, oi) in item.options" :key="oi" :class="getOptionClass(item, opt.alisa)">
              <span class="radio"></span>{{ opt.alisa }}. <span v-html="opt.text"></span>
            </li>
          </ul>
          <div class="analysis-box">
            <p class="label">解析</p>
            <div v-if="item.type === 'BLANKFILL'" class="blank-rows">
              <div v-for="(b, bi) in (item.blanks || [])" :key="bi" class="blank-row">
                {{ bi + 1 }}. <span class="blank-value">{{ b.value || '—' }}</span>
              </div>
            </div>
            <template v-else>
              <p class="answer" v-if="item.answer">正确答案：{{ item.answer }}</p>
              <p class="detail" v-if="item.analysis"><span v-html="item.analysis"></span></p>
            </template>
          </div>
        </div>
        <div class="empty-state" v-if="favList.length === 0">
          <el-empty description="暂无收藏"></el-empty>
        </div>
      </div>
      <div class="fav-list-pagination">
        <el-pagination
          layout="prev, pager, next"
          :total="favTotal"
          :page-size="favPageSize"
          :current-page.sync="favPage"
          @current-change="getFavList"
          background
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { quesMap } from "@/utils/enums";

export default {
  name: "FavModal",
  props: {
    visible: { type: Boolean, default: false },
    courseId: { type: String, default: '' },
    paperId: { type: String, default: '' },
  },
  data() {
    return {
      quesMap,
      favList: [],
      favTotal: 0,
      favPage: 1,
      favPageSize: 10,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.favPage = 1;
        this.getFavList();
      }
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
    },
    getFavList() {
      const params = { courseId: this.courseId, current: this.favPage, size: this.favPageSize };
      if (this.paperId) params.paperId = this.paperId;
      this.$http.get('/student/pc/freeStudy/favList', params).then(res => {
        this.favList = (res.records || []).map(item => {
          if (item.type === 'BLANKFILL') {
            item.content = (item.content || item.title || '').replace(/\[BlankArea\d+\]/g, '______');
          }
          return item;
        });
        this.favTotal = +res.total || 0;
      });
    },
    deleteFavItem(item) {
      this.$confirm('确定要删除这道收藏试题吗？此操作不可恢复。', '删除收藏', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.post('/student/pc/freeStudy/deleteFav', { questionId: item.id, courseId: this.courseId }).then(() => {
          this.$message.success('删除成功');
          const newTotal = this.favTotal - 1;
          if (this.favPage > 1 && (this.favPage - 1) * this.favPageSize >= newTotal) {
            this.favPage--;
          }
          this.getFavList();
          this.$emit('deleted');
        });
      }).catch(() => {});
    },
    getOptionClass(q, val) {
      if (q.type === 'MULTIPLECHOICE') {
        const isAnswer = q.answer && q.answer.includes(val);
        return isAnswer ? { correct: true } : {};
      }
      if (val === q.answer) return { correct: true };
      return {};
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/variable.scss";
.custom-modal-mask {
  position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,.5);
  z-index: 2000; display: flex; align-items: flex-start; justify-content: center; padding-top: 8vh;
  overflow-y: auto;
}
.custom-modal {
  background: #fff; border-radius: 10px; border: 1px solid #e3e3e3; box-shadow: 0 4px 20px rgba(0,0,0,.15);
  max-height: 84vh; display: flex; flex-direction: column;
}
.custom-modal-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 24px; background: $primary-light; border-bottom: 1px solid $primary-border; border-radius: 10px 10px 0 0; flex-shrink: 0;
  .modal-title { font-size: 15px; font-weight: bold; color: #333; }
  .count { font-size: 13px; font-weight: normal; color: #999; margin-left: 8px; }
}
.custom-modal-close {
  font-size: 22px; color: #999; cursor: pointer; line-height: 1; padding: 0 4px;
  &:hover { color: #333; }
}
.custom-modal-body {
  flex: 1; overflow-y: auto; padding: 20px 24px;
}
.empty-state { text-align: center; padding: 60px 0; color: #999; font-size: 14px; .icon { font-size: 48px; margin-bottom: 16px; color: #ddd; } }
.q-options {
  list-style: none; padding: 0;
  li {
    padding: 8px 14px; margin-bottom: 6px; border-radius: 6px; border: 1px solid #e3e3e3;
    font-size: 14px; display: flex; align-items: center; gap: 8px;
    .radio { width: 16px; height: 16px; border-radius: 50%; border: 2px solid #ccc; flex-shrink: 0; display: flex; align-items: center; justify-content: center; }
    &.correct { border-color: #67c23a; background: #f0f9eb; .radio { border-color: #67c23a; background: #67c23a; &::after { content: '\2713'; color: #fff; font-size: 10px; line-height: 1; } } }
    &.wrong { border-color: #f56c6c; background: #fef0f0; .radio { border-color: #f56c6c; &::after { content: '\2717'; color: #f56c6c; font-size: 10px; line-height: 1; } } }
  }
}
.analysis-box {
  background: #f9f9f9; border-radius: 8px; padding: 14px 18px; margin-top: 12px; border-left: 3px solid $primary-dark;
  .label { font-size: 13px; color: $primary-dark; font-weight: bold; margin-bottom: 6px; }
  .answer { font-size: 13px; color: #333; margin-bottom: 4px; }
  .detail { font-size: 13px; color: #666; line-height: 1.8; }
}
.blank-rows { margin-bottom: 8px; }
.blank-row {
  display: flex; align-items: center; gap: 12px;
  padding: 8px 14px; margin-bottom: 6px; border-radius: 6px; border: 1px solid #e3e3e3; font-size: 13px; color: #333;
}
.fav-list-item { padding: 20px 24px; border-bottom: 1px solid #f2f2f2; &:last-child { border-bottom: none; } }
.fav-list-head { margin-bottom: 12px; }
.fav-list-head-row { display: flex; align-items: center; gap: 10px; margin-bottom: 8px; flex-wrap: wrap; }
.fav-list-num { display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; border-radius: 50%; background: $primary-light; color: $primary-dark; font-size: 13px; font-weight: bold; flex-shrink: 0; }
.fav-list-type { display: inline-block; padding: 2px 8px; border-radius: 4px; font-size: 12px; background: $primary-light; color: $primary-dark; font-weight: bold; &.judge { background: #fff3e0; color: #e6a23c; } &.essay { background: #f0f0ff; color: #6366f1; } }
.fav-list-title { font-size: 14px; color: #333; line-height: 1.6; word-break: break-all; }
.fav-list-time { margin-left: auto; font-size: 12px; color: #999; white-space: nowrap; flex-shrink: 0; margin-right: 12px; }
.fav-list-delete { display: inline-flex; align-items: center; padding: 3px 12px; font-size: 12px; color: #f56c6c; border: 1px solid #f56c6c; border-radius: 14px; cursor: pointer; background: #fff; flex-shrink: 0; &:hover { background: #fef0f0; } }
.fav-list-pagination { padding: 16px 24px; border-top: 1px solid #f2f2f2; display: flex; justify-content: center; flex-shrink: 0; }
</style>
